import { render, staticRenderFns } from "./BaseAnswerForm.vue?vue&type=template&id=7100f385&scoped=true&"
import script from "./BaseAnswerForm.vue?vue&type=script&lang=js&"
export * from "./BaseAnswerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7100f385",
  null
  
)

export default component.exports